<script setup lang="ts">
import { AuthRegisterForm } from '@/modules/auth/components';
import { useAuthStore } from '@/modules/auth/store/auth';

useHead({
  title: 'Sign Up',
});

definePageMeta({
  layout: 'guest',
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: () => {
      const { getUser, hasLoggedInUser } = useAuthStore();
      return hasLoggedInUser && getUser?.email_verified ? '/' : '/login';
    },
  },
});
</script>
<template>
  <v-container class="d-flex align-center hero">
    <AuthRegisterForm data-testid="register-form" />
  </v-container>
</template>
<style lang="scss" scoped>
.v-form {
  width: 100%;
  max-width: 500px;
  display: inline-block;
  position: relative;
  margin: auto;
}
</style>
